import { normalizeApiError } from '../api/apiError';

const MESSAGES: Record<string, string> = {
  WFH_REQUEST_NOT_FOUND: 'WFH request was not found.',
  WFH_NOT_ELIGIBLE: 'You are not eligible to request work from home.',
  WFH_EMPLOYEE_NOT_ELIGIBLE: 'This employee is not eligible for WFH.',
  WFH_ON_BEHALF_NOT_ALLOWED:
    'You can apply for WFH only for yourself.',
  WFH_TEAM_MEMBER_REQUIRED:
    'You can apply for WFH only for employees assigned to you.',
  WFH_DATE_OVERLAP: 'The selected dates overlap an existing request.',
  WFH_LEAVE_OVERLAP:
    'The selected dates overlap an approved leave request.',
  WFH_POLICY_NOT_FOUND: 'A work-from-home policy is not assigned.',
  WFH_LIMIT_EXCEEDED:
    'The allowed work-from-home limit has been exceeded.',
  WFH_REQUEST_NOT_CANCELLABLE:
    'This WFH request can no longer be canceled.',
  WORKFLOW_NOT_CONFIGURED: 'The approval workflow is not configured.',
  ACCESS_DENIED: 'You do not have permission to perform this action.',
  VALIDATION_ERROR: 'Check the entered WFH information.',
  INVALID_DATE_RANGE: 'The selected date range is invalid.',
  NETWORK_ERROR: 'Unable to connect to the server.',
  REQUEST_TIMEOUT: 'The server took too long to respond.',
  EMPLOYEE_PROFILE_REQUIRED: 'An employee profile is required for WFH.',
};

export function wfhErrorMessage(
  error: unknown,
  fallback = 'Unable to load WFH information.',
): string {
  if (
    typeof error === 'object' &&
    error !== null &&
    'code' in error &&
    typeof (error as { code?: unknown }).code === 'string'
  ) {
    const code = (error as { code: string }).code;
    if (MESSAGES[code]) return MESSAGES[code];
  }

  const apiError = normalizeApiError(error);
  if (apiError.code && MESSAGES[apiError.code]) {
    return MESSAGES[apiError.code];
  }
  if (apiError.message?.trim()) {
    return apiError.message.trim();
  }
  return fallback;
}
